'use client';

import MenuItem from '@mui/material/MenuItem';
import { PropsWithChildren } from 'react';

export interface Props {
	onClick: () => void;
	disabled?: boolean;
}

const Item = ({ children, onClick, disabled }: PropsWithChildren<Props>) => {
	return (
		<MenuItem onClick={onClick} disabled={disabled}>
			{children}
		</MenuItem>
	);
};

export default Item;
